import { Type } from '@angular/core';

export class DevFuncItem {
  constructor(public component: Type<any>, public name: string, public title: string, public data?: any) {}
}
